import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& input': {
    color: '#333333',
    WebkitTextFillColor: '#333333',
    '&::placeholder': {
      fontStyle: 'italic',
      opacity: 1,
    },
  },
  '& .MuiInputBase-input.Mui-disabled': {
    color: '#d2d4d7',
    WebkitTextFillColor: '#d2d4d7',
  },
}));
